import { Observable } from "rxjs"

import {
    EVIDENCE_ADD_REQUEST,
    EVIDENCE_LIST_REQUEST
} from "../actions/action-types"
import {
    evidenceAddResponse,
    evidenceItemErrorResponse,
    evidenceListCachedResponse,
    evidenceListResponse
} from "../actions/evidence-actions"
import { getEvidenceList, postEvidenceUrl } from "../api/evidence-api"
import { mapRequestError } from "./default-epics/epic-utils"
import { unauthenticated } from "../actions/authentication-actions"

export const postEvidenceUrlEpic = (action$, { getState }) =>
    action$.ofType(EVIDENCE_ADD_REQUEST).mergeMap(action =>
        postEvidenceUrl(getState().authentication.token, action.link)
            .map(data => {
                return evidenceAddResponse(data, action.roleID)
            })
            .catch(error =>
                Observable.of(
                    mapRequestError(
                        error,
                        unauthenticated,
                        evidenceItemErrorResponse,
                        action.roleID
                    )
                )
            )
    )

export const requestEvidenceListEpic = (action$, { getState }) =>
    action$.ofType(EVIDENCE_LIST_REQUEST).mergeMap(action => {
        const stakeholderID =
            action.stakeholderID ||
            getState().presentation.stakeholders.activeId

        const authToken = getState().authentication.token

        const roleID = action.roleID

        const evidenceItems = getState().presentation.evidence[roleID].items

        if (evidenceItems && evidenceItems.length > 0) {
            return Observable.of(evidenceListCachedResponse(roleID))
        } else {
            return getEvidenceList(authToken, stakeholderID, roleID)
                .map(data => evidenceListResponse(data, roleID))
                .catch(error =>
                    Observable.of(
                        mapRequestError(
                            error,
                            unauthenticated,
                            evidenceItemErrorResponse
                        )
                    )
                )
        }
    })
